import { useFetchEventsList } from 'hooks/promoRecommendation/useFetchEventsListData';
import _ from 'lodash';
import react, { useState, createContext, FC, useContext, useEffect, useRef } from 'react';
import { UserContext } from './ConfigContext';
import { formatNumWithKMB, getConfig } from 'utils/helperMethods';
import { formatAddSpends, formatDim1_data } from 'components/organism/PromoRecommendation/AddEditEventModal';
import { FilterContextData } from './FilterContext';
import dayjs from 'dayjs';
import { useFetchBaselineUpliftData } from 'hooks/promoRecommendation/useFetchBaselineUpliftData';
import { useFetchGetPromptsPreviousBaselineList } from 'hooks/promoRecommendation/UseFetchGetPromtsPreviousBaselineListData';
import { useFetchAdditionalKpis } from 'hooks/promoRecommendation/useFetchAdditionalKpis';

const promoRecommendation = createContext<{
    setAddLeverData: Function;
    addLeverData: any;
    selectedPlan: any;
    setSelectPlan: Function;
    loadingForPlanList: any;
    setLoadingForPlanList: Function;
    selectedKpiList: any[];
    setSelectedKpiList: Function;
    addSpends: any;
    setAddSpends: Function;
    eventsListData: any;
    eventsListError: any;
    eventsListLoading: boolean;
    deleteEvent: Function;
    fetchEventsList: Function;
    clearEventsList: Function;
    addEditModal: any;
    setAddEditModal: Function;
    editPlan: Function;
    editMode: any;
    setEditMode: Function;
    spendType: [];
    setSpendType: Function;
    tempRange: any;
    setTempRange: Function;
    stateForCalender: any;
    setStateForCalender: Function;
    resetAllStateForAdd: Function;
    editOriginalData: any;
    editRowData: any;
    modelRecommendedData: any[];
    setEditRowData: Function;
    eventsDataFormat: Function;
    eventDataFromOriginalData: Function;
    checkIfDataPresentAndFetchData: Function;
    additionalKpiLoading: boolean;
    baselineUpliftLoading: boolean;
    baselineLoading: boolean;
    PreviousUpliftValue: any;
    PromotionMechanicValue: any;
    PromotionMechanicValueData: any;
}>({
    setAddLeverData: () => {},
    addLeverData: {},
    selectedPlan: {},
    setSelectPlan: () => {},
    loadingForPlanList: '',
    setLoadingForPlanList: () => {},
    selectedKpiList: [],
    setSelectedKpiList: () => {},
    addSpends: {},
    setAddSpends: () => {},
    eventsListData: null,
    eventsListError: null,
    eventsListLoading: false,
    deleteEvent: () => {},
    fetchEventsList: () => {},
    clearEventsList: () => {},
    addEditModal: false,
    setAddEditModal: () => {},
    editPlan: () => {},
    editMode: false,
    setEditMode: () => {},
    spendType: [],
    setSpendType: () => {},
    tempRange: [],
    setTempRange: () => {},
    stateForCalender: {},
    setStateForCalender: () => {},
    resetAllStateForAdd: () => {},
    editOriginalData: {},
    editRowData: {},
    setEditRowData: () => {},
    eventsDataFormat: () => {},
    eventDataFromOriginalData: () => {},
    checkIfDataPresentAndFetchData: () => {},
    modelRecommendedData: [],
    additionalKpiLoading: false,
    baselineUpliftLoading: false,
    baselineLoading: false,
    PreviousUpliftValue: '',
    PromotionMechanicValue: '',
    PromotionMechanicValueData: '',
});
interface props {
    children: React.ReactNode;
}

const PromoRecommendationContext: FC<props> = ({ children }) => {
    const { appConfig } = useContext(UserContext);
    const {
        leverKeys,
        spendTopForm,
        offerSelectionKeys,
        formList,
        retailerKey,
        hideAddSpends,
        spendPerQtyKey,
        spendTypeList,
        overlayKeys,
    } = getConfig('promoRecommendation', appConfig);

    const isDisplayAcvHidden = !formList?.some((item: any) => item.value === 'displayAcv');
    const isFeatureAcvHidden = !formList?.some((item: any) => item.value === 'featureAcv');
    const kpiTableDataKeyMapping = overlayKeys?.slice(4);
    const [addLeverData, setAddLeverData] = useState<any>({ SelectedLowerLevel: {} });
    const [selectedPlan, setSelectPlan] = useState<any>();
    const [loadingForPlanList, setLoadingForPlanList] = useState<boolean>();
    const [selectedKpiList, setSelectedKpiList] = useState(kpiTableDataKeyMapping.map((item: any) => item.label) || []);
    const [addSpends, setAddSpends] = useState<any>(() => ({ per_qty: {} }));
    const [addEditModal, setAddEditModal] = useState(false);
    const [PromotionMechanicValueData, setPromotionMechanicValueData] = useState();
    const [editMode, setEditMode] = useState(false);
    const [spendType, setSpendType] = useState<any>([]);
    const [tempRange, setTempRange] = useState<any>([null]);
    const [stateForCalender, setStateForCalender] = useState({ step: 1, dateRange: [null] });
    const [editOriginalData, setEditOriginalData] = useState<any>({});
    const [editRowData, setEditRowData] = useState<any>({});
    const [isLeftSideFilled, setIsLeftSideFilled] = useState(false);
    const [modelRecommendedData, setModelRecommendedData] = useState<any[]>([]);

    const { idForRestOfComponent, allCheckedAttribute, currentFrequency } = useContext(FilterContextData);
    const abortModelRecData = useRef(false);
    const [upliftValue, setUpliftValue] = useState('');
    const [MechanicValue, setMechanicValue] = useState('');

    const PreviousUpliftValue = (value: any) => {
        setUpliftValue(value);
    };
    const PromotionMechanicValue = (value: any) => {
        setMechanicValue(value);
        setPromotionMechanicValueData(value);
    };

    //hooks
    //events list and calender/kpi hook
    const {
        data: eventsListData,
        error: eventsListError,
        loading: eventsListLoading,
        deleteEvent,
        clearEventsList,
        fetchEventsList,
    } = useFetchEventsList();

    //baseline uplift hook
    const {
        error: baselineUpliftError,
        loading: baselineUpliftLoading,
        fetchBaselineUpliftData,
        setLoading: baselineUpliftSetLoading,
    } = useFetchBaselineUpliftData({ onCompleted: onFetchBaselineUpliftComplete });

    //baseline  hook

    const {
        error: baselineError,
        loading: baselineLoading,
        fetchOfferPreviousBaselineList,
        setLoading: baselineSetLoading,
    } = useFetchGetPromptsPreviousBaselineList({ onCompleted: onFetchBaselineComplete });

    const {
        error: additionalKpiError,
        loading: additionalKpiLoading,
        fetchAdditionalKpiData,
        setLoading: additionalKpiSetLoading,
    } = useFetchAdditionalKpis({ onCompleted: onFetchAdditionalKpisComplete });

    function formatPPGSelection(data: any) {
        let ppgSelection: any = {};
        data.forEach((ppg: any) => {
            ppgSelection[ppg.dim1Name] = {
                dim1Id: ppg.dim1Id,
                label: ppg.dim1Name,
                openStock: ppg.openStock,
                shipperStock: ppg.shipperStock,
                colorChange: true,
                promptName: ppg.dim1Name,
            };
        });
        return ppgSelection;
    }

    //isEmpty check
    function isEmpty(value: any) {
        return !(value == null || value.length === 0);
    }

    //spend dropdown data to
    function spendDataFormatForEventData(currentSpendData: any, editOriginalData: any) {
        let temp: any = {};
        spendType.forEach((spendKey: any) => {
            if (spendKey == 'per_qty') {
                temp['per_qty'] = updatedValue('spends', editOriginalData['per_qty'], currentSpendData['per_qty']);
                temp['redemption'] = updatedValue(
                    'redemption',
                    editOriginalData['per_qty'],
                    currentSpendData['per_qty'],
                );
            } else {
                temp[spendKey] = updatedValue(spendKey, editOriginalData, currentSpendData);
            }
        });
        return temp;
    }

    //take value only when user enters new value
    function updatedValue(key: string, original: any, updated: any) {
        console.log(key, original, updated);
        let dataReturn =
            updated && key in updated && isEmpty(updated[key])
                ? updated[key]
                : original && original[key] !== undefined
                ? original[key]
                : 0;
        return dataReturn;
    }

    //event data object for edit and prompt list
    function eventsDataFormat(editRowData: any, addSpendsData?: any) {
        let event_data: any = {
            spends_data: {},
        };
        event_data['dim1_data'] = formatDim1_data(addLeverData['SelectedLowerLevel']);
        event_data['dim2_ids'] = idForRestOfComponent.dim2.ids;
        // event_data['event_name'] = event_data['event_name'] = `${
        //     Object.keys(allCheckedAttribute['Retailer'])[0]
        // } ${updatedValue('promotionMechanic', editOriginalData, addLeverData)} ${
        //     'month' in addLeverData
        //         ? dayjs(addLeverData['startDate']).format('MMM')
        //         : dayjs(editOriginalData['startDate']).format('MMM')
        // }`;
        //lever data
        leverKeys.forEach((key: string) => {
            event_data[key] = updatedValue(key, editRowData, addLeverData);
        });

        //added all keys from add lever except spend selection
        spendTopForm.forEach((key: string) => {
            event_data[key] = updatedValue(key, editRowData, addSpendsData || addSpends);
        });
        let spendDataMerged = spendDataFormatForEventData(addSpendsData || addSpends, editOriginalData);
        event_data['spends_data'] = spendDataMerged;
        event_data['tacticDescription'] = updatedValue('tacticDescription', editOriginalData, addLeverData);
        event_data['offerMethod'] = updatedValue('offerMethod', editOriginalData, addLeverData);
        if (event_data['offerMethod'] === 'option') {
            delete event_data['discount'];
            delete event_data['promptEventName'];
            event_data['promotionMechanic'] = updatedValue('promotionMechanic', editOriginalData, addLeverData);
            event_data['event_name'] = event_data['event_name'] = `${
                Object.keys(allCheckedAttribute[retailerKey])[0]
            } ${updatedValue('promotionMechanic', editOriginalData, addLeverData)} ${
                'month' in addLeverData
                    ? dayjs(addLeverData['startDate']).format('MMM')
                    : dayjs(editOriginalData['startDate']).format('MMM')
            }`;
        }

        if (event_data['offerMethod'] === 'manual') {
            delete event_data['promptEventName'];
            event_data['promotionMechanic'] = updatedValue('discount', editOriginalData, addLeverData);
            event_data['discount'] = parseInt(updatedValue('discount', editOriginalData, addLeverData));
            event_data['event_name'] = event_data['event_name'] = `${
                Object.keys(allCheckedAttribute[retailerKey])[0]
            } ${updatedValue('discount', editOriginalData, addLeverData)}%_Off ${
                'month' in addLeverData
                    ? dayjs(addLeverData['startDate']).format('MMM')
                    : dayjs(editOriginalData['startDate']).format('MMM')
            }`;
        }
        if (event_data['offerMethod'] === 'previous') {
            delete event_data['discount'];
            event_data['promotionMechanic'] = updatedValue('promptEventName', editOriginalData, addLeverData);
            event_data['promptEventName'] = updatedValue('promptEventName', editOriginalData, addLeverData);
            event_data['event_name'] = event_data['event_name'] = `${
                Object.keys(allCheckedAttribute[retailerKey])[0]
            } ${updatedValue('promptEventName', editOriginalData, addLeverData)} ${
                'month' in addLeverData
                    ? dayjs(addLeverData['startDate']).format('MMM')
                    : dayjs(editOriginalData['startDate']).format('MMM')
            }`;
        }
        return event_data;
    }

    //editRow data dim1 data transform
    function transformEditDim1ToObject(dim1Edit: any[]) {
        const outputObject: any = {};
        for (const item of dim1Edit) {
            const { dim1Id, openStock, shipperStock } = item;

            outputObject[dim1Id] = {
                open_stock: openStock,
                shipper_stock: shipperStock,
            };
        }
        return outputObject;
    }

    //event data from original data
    function eventDataFromOriginalData(editRowData: any) {
        let event_data: any = {
            spends_data: {},
        };
        event_data['dim1_data'] = transformEditDim1ToObject(editRowData.dim1Data);
        event_data['dim2_ids'] = idForRestOfComponent.dim2.ids;
        event_data['event_name'] = editRowData.eventName;
        leverKeys.forEach((key: string) => {
            event_data[key] = editOriginalData[key];
        });
        spendTopForm.forEach((key: string) => {
            event_data[key] = editOriginalData[key];
        });
        event_data['spends_data'] = JSON.parse(editRowData['spendsData']);
        offerSelectionKeys.forEach((key: string) => {
            event_data[key] = editRowData[key];
        });
        return event_data;
    }

    //event data transform for baseline uplift
    function transformEventDataForBaseline(checkRight: boolean = false, spendsData?: any) {
        let event_data: any = {
            spends_data: {},
        };
        //added all keys from add lever except ppg selection
        leverKeys.forEach((key: string) => {
            event_data[key] = addLeverData[key];
        });
        if (checkRight) {
            //added all keys from add lever except spend selection
            spendTopForm.forEach((key: string) => {
                event_data[key] = spendsData[key];
            });
            event_data['spends_data'] = formatAddSpends(spendType, spendsData);
        }

        //rest of data
        event_data['dim2_ids'] = idForRestOfComponent.dim2.ids;
        event_data['dim1_data'] = formatDim1_data(addLeverData['SelectedLowerLevel']);
        event_data['offerMethod'] = `${addLeverData['offerMethod']}`;
        if (event_data['offerMethod'] === 'manual') {
            event_data['event_name'] = `${Object.keys(allCheckedAttribute[retailerKey])[0]} ${
                addLeverData['discount']
            }%_Off ${addLeverData['month']}`;
            event_data['promotionMechanic'] = `${addLeverData['discount']}%_Off`;
            event_data['discount'] = parseInt(`${addLeverData['discount']}`);
        } else if (event_data['offerMethod'] === 'previous') {
            event_data['event_name'] = `${Object.keys(allCheckedAttribute[retailerKey])[0]} ${MechanicValue} ${
                addLeverData['month']
            }`;
            event_data['promotionMechanic'] = MechanicValue;
            event_data['promptEventName'] = `${addLeverData['promptEventName']}`;
        } else {
            event_data['event_name'] = `${Object.keys(allCheckedAttribute[retailerKey])[0]} ${
                addLeverData['promotionMechanic']
            } ${addLeverData['month']}`;
            event_data['promotionMechanic'] = `${addLeverData['promotionMechanic']}`;
        }
        event_data['tacticDescription'] = `${addLeverData['tacticDescription']}`;

        return event_data;
    }

    //value selection of edit value according to type
    function onEditValueSet(key: any, data: any) {
        if (typeof data[key] === 'string') {
            return data[key];
        } else if (typeof data[key] === 'number') {
            return parseFloat(data[key].toFixed(2));
        } else {
            return null; // or some appropriate default value
        }
    }

    //edit row function to populate form
    function editPlan(data: any) {
        setEditRowData(() => ({ ...data }));
        resetAllStateForAdd();
        setEditMode(() => true);
        setAddEditModal(true);

        //to store ppg selection from edit row
        setAddLeverData((oldData: any) => {
            let temp = _.cloneDeep(oldData);
            temp['SelectedLowerLevel'] = formatPPGSelection(data.dim1Data);
            return temp;
        });

        //change the structure of per_qty later

        let rowSpendData = JSON.parse(data.spendsData);
        let spendDataSelection: any = [];
        let spendDataParsed: any = { per_qty: {} };

        //helps parse spend type data from table row
        for (let spendKey in rowSpendData) {
            if (spendKey !== 'redemption') {
                spendDataSelection.push(spendKey);
            }
            if (spendPerQtyKey.includes(spendKey)) {
                if (spendPerQtyKey[0] == spendKey) {
                    spendDataParsed.per_qty['spends'] = rowSpendData[spendKey];
                } else {
                    spendDataParsed.per_qty[spendKey] = rowSpendData[spendKey];
                }
            } else {
                spendDataParsed[spendKey] = rowSpendData[spendKey];
            }
        }
        spendDataSelection.push('promoSpends');
        //to set list of add spend dropdown
        setSpendType(() => [...spendDataSelection]);

        //populate original data
        setEditOriginalData((oldData: any) => {
            let dataTemp = _.cloneDeep(oldData);

            leverKeys.forEach((key: string) => {
                dataTemp[key] = onEditValueSet(key, data);
            });
            spendTopForm.forEach((key: string) => {
                dataTemp[key] = onEditValueSet(key, data);
            });
            offerSelectionKeys.forEach((key: string) => {
                dataTemp[key] = onEditValueSet(key, data);
            });
            dataTemp['promoSpends'] = onEditValueSet('promoSpends', data);
            return { ...dataTemp, ...spendDataParsed };
        });
    }

    //state reset function
    function resetAllStateForAdd() {
        setAddLeverData(() => ({ SelectedLowerLevel: {} }));
        setAddSpends(() => ({ per_qty: {} }));
        setSpendType(() => []);
        setTempRange(() => [null]);
        setStateForCalender(() => ({ step: 1, dateRange: [null] }));
        setEditOriginalData({});
        setEditMode(false);

        //change loading state for model recommended query when user closes the add/edit modal
        abortModelRecData.current = true;
        additionalKpiSetLoading(false);
        baselineUpliftSetLoading(false);
        baselineSetLoading(false);
    }

    function checkAndUpdateFeatureDisplayAcvData(data: any, setFunction: Function) {
        //if display feature acv is hidden and display acv is not present, set default display acv to 0
        if (isDisplayAcvHidden && !('displayAcv' in data)) {
            setFunction((prev: any) => ({ ...prev, displayAcv: 0 }));
        }

        //if display feature acv is hidden and feature acv is not present, set default feature acv to 0
        if (isFeatureAcvHidden && !('featureAcv' in data)) {
            setFunction((prev: any) => ({ ...prev, featureAcv: 0 }));
        }
    }

    //check if left side of add/edit modal is fully filled
    function checkIfLeftSideFilled(data: any, setFunction: Function) {
        let totalVariables = editMode ? 7 : 8;
        checkAndUpdateFeatureDisplayAcvData(data, setFunction);
        //checking if all the input fields are filled
        //there are total 8 keys to be filled as of now
        if (Object.keys(data).length < totalVariables) return false;

        let areAllValuesPresent = true;
        if (!editMode) {
            Object.keys(data).forEach((item: any) => {
                if (!(typeof data[item] === 'object' || _.isString(data[item]) || _.isFinite(data[item]))) {
                    areAllValuesPresent = false;
                }
            });
        }

        if ('SelectedLowerLevel' in data && areAllValuesPresent) {
            //this means no product is selected
            if (Object.keys(data['SelectedLowerLevel']).length === 0) {
                return false;
            }
            //checking if ope stock and shipper stock is present
            let isStockPresent = false;
            Object.keys(data['SelectedLowerLevel']).forEach((item: any) => {
                if (
                    _.isFinite(data['SelectedLowerLevel'][item]['openStock']) &&
                    _.isFinite(data['SelectedLowerLevel'][item]['shipperStock'])
                ) {
                    isStockPresent = true;
                } else isStockPresent = false;
            });
            if (isStockPresent) return true;
        }

        return false;
    }

    function checkIfRightSideEmpty(data?: any) {
        //if hide add spends is true, then check if lump_sum is present in addSpends
        if (hideAddSpends) {
            //if lump_sum is not present in addSpends, then set it to  default 0
            if (!('lump_sum' in addSpends)) setAddSpends((prev: any) => ({ ...prev, lump_sum: 0 }));
            return false;
        }
        const toCheckData = data ? data : addSpends;
        let isEmpty = true;
        spendTypeList?.forEach((item: any) => {
            if (toCheckData && item?.value in toCheckData) {
                if (item?.value === 'per_qty') {
                    if (
                        _.isFinite(toCheckData[item?.value]?.['redemption']) &&
                        _.isFinite(toCheckData[item?.value]?.['spends'])
                    ) {
                        isEmpty = false;
                    }
                } else if (item?.value in toCheckData && _.isFinite(toCheckData[item?.value])) isEmpty = false;
            }
        });
        return isEmpty;
    }
    //called when baseline uplift query is completed
    function onFetchBaselineUpliftComplete(payload: any) {
        if (abortModelRecData.current) return;
        const { getUpliftAndBaseline } = payload;
        if (getUpliftAndBaseline && 'uplift' in getUpliftAndBaseline && 'baseVolume' in getUpliftAndBaseline) {
            const formattedUplift = _.round(getUpliftAndBaseline.uplift, 2);
            const formattedBaseVolume = _.round(getUpliftAndBaseline.baseVolume, 2);
            const totalVolume = formattedUplift * formattedBaseVolume;
            const formattedTotalVolume = _.round(totalVolume, 2);

            //only for add
            if (!editMode) {
                const tempData = {
                    uplift: formattedUplift,
                    baseVolume: formattedBaseVolume,
                    totalVolume: isNaN(formattedTotalVolume) ? 0 : formattedTotalVolume,
                };
                setAddSpends({ ...addSpends, ...tempData });
            }
            setModelRecommendedData((oldData: any[]) => {
                return [
                    {
                        value: formattedBaseVolume.toLocaleString(),
                    },
                    {
                        value: formattedUplift.toLocaleString(),
                    },
                    {
                        value: isNaN(formattedTotalVolume) ? 0 : formattedTotalVolume.toLocaleString(),
                    },
                ];
            });
        }
    }

    //called when baseline  query is completed
    function onFetchBaselineComplete(payload: any) {
        if (abortModelRecData.current) return;
        const formattedBaseVolume = _.round(payload.getBaselineData.baseVolume, 2);
        const formattedUplift = _.round(parseFloat(upliftValue), 2);
        const totalVolume = formattedUplift * formattedBaseVolume;
        const formattedTotalVolume = _.round(totalVolume, 2);

        //only for add
        if (!editMode) {
            const tempData = {
                uplift: formattedUplift,
                baseVolume: formattedBaseVolume,
                totalVolume: isNaN(formattedTotalVolume) ? 0 : formattedTotalVolume,
            };
            setAddSpends({ ...addSpends, ...tempData });
        }
        setModelRecommendedData((oldData: any[]) => {
            return [
                {
                    value: formattedBaseVolume.toLocaleString(),
                },
                {
                    value: formattedUplift.toLocaleString(),
                },
                {
                    value: isNaN(formattedTotalVolume) ? 0 : formattedTotalVolume.toLocaleString(),
                },
            ];
        });
    }

    function onFetchAdditionalKpisComplete(payload: any) {
        if (abortModelRecData.current) return;
        const { getAdditionalModelRecommendedKpis } = payload;
        if (getAdditionalModelRecommendedKpis && 'roi' in getAdditionalModelRecommendedKpis) {
            const formattedRoi = _.round(getAdditionalModelRecommendedKpis.roi[0], 2);
            const formattedRecommendedRoi = _.isNull(getAdditionalModelRecommendedKpis.roi[1])
                ? null
                : _.round(getAdditionalModelRecommendedKpis.roi[1], 2);
            const formattedProfit = _.round(getAdditionalModelRecommendedKpis.totalKindProfit[0], 2);
            const formattedRecommendedProfit = _.isNull(getAdditionalModelRecommendedKpis.totalKindProfit[1])
                ? null
                : _.round(getAdditionalModelRecommendedKpis.totalKindProfit[1], 2);
            const formattedRetailerProfit = _.round(getAdditionalModelRecommendedKpis.totalRetailerProfit[0], 2);
            const formattedRecommendedRetailerProfit = _.isNull(
                getAdditionalModelRecommendedKpis.totalRetailerProfit[1],
            )
                ? null
                : _.round(getAdditionalModelRecommendedKpis.totalRetailerProfit[1], 2);
            const formattedTotalPromoSpends = _.round(getAdditionalModelRecommendedKpis.promoSpends[0], 2);
            const formattedTotalGsv = _.round(getAdditionalModelRecommendedKpis.totalGsv[0], 2);
            const tempData = {
                roi: formattedRoi,
                totalKindProfit: formattedProfit,
                totalRetailerProfit: formattedRetailerProfit,
                promoSpends: formattedTotalPromoSpends,
                totalGsv: formattedTotalGsv,
            };
            setAddSpends({ ...addSpends, ...tempData });
            setModelRecommendedData((oldData: any[]) => {
                return [
                    oldData[0],
                    oldData[1],
                    oldData[2],
                    {
                        value: formattedRecommendedProfit
                            ? formattedRecommendedProfit.toLocaleString()
                            : formattedRecommendedProfit,
                    },
                    {
                        value: formattedRecommendedRoi
                            ? formattedRecommendedRoi.toLocaleString()
                            : formattedRecommendedRoi,
                    },
                    {
                        value: formattedRecommendedRetailerProfit
                            ? formattedRecommendedRetailerProfit.toLocaleString()
                            : formattedRecommendedRetailerProfit,
                    },
                ];
            });
        }
    }

    //check if both left side and right side in not empty

    function checkIfDataPresentAndFetchData(spendsData: any) {
        const isEditMode = editMode && editRowData;
        if (
            isEditMode ||
            (checkIfLeftSideFilled(
                isEditMode ? eventsDataFormat(editRowData) : addLeverData,
                isEditMode ? setEditRowData : setAddLeverData,
            ) &&
                !checkIfRightSideEmpty(spendsData))
        ) {
            const variables = isEditMode
                ? eventsDataFormat(editRowData, spendsData)
                : transformEventDataForBaseline(true, spendsData);
            fetchAdditionalKpiData({
                variables: {
                    eventData: JSON.stringify(variables),
                    frequency: currentFrequency?.key,
                },
            });
        } else {
            setModelRecommendedData((oldData: any[]) => {
                return [oldData[0], oldData[1], oldData[2]];
            });
        }
    }

    useEffect(() => {
        //edit mode
        if (editMode && editRowData) {
            let tempData = eventsDataFormat(editRowData);
            setModelRecommendedData([]);
            abortModelRecData.current = false;
            if (tempData.offerMethod === 'previous') {
                fetchOfferPreviousBaselineList({
                    variables: {
                        eventData: JSON.stringify(tempData),
                        frequency: currentFrequency?.key,
                    },
                });
            } else {
                fetchBaselineUpliftData({
                    variables: {
                        eventData: JSON.stringify(tempData),
                        planId: selectedPlan?.planId,
                        frequency: currentFrequency?.key,
                        dim2AttributeName: `${Object.keys(allCheckedAttribute?.[retailerKey])?.[0]}`,
                    },
                });
            }
            checkIfDataPresentAndFetchData(editRowData);
        }
        //add mode
        else if (checkIfLeftSideFilled(addLeverData, setAddLeverData)) {
            const variables = transformEventDataForBaseline(false);
            setModelRecommendedData([]);
            abortModelRecData.current = false;
            if (variables.offerMethod === 'previous') {
                fetchOfferPreviousBaselineList({
                    variables: {
                        eventData: JSON.stringify(variables),
                        frequency: currentFrequency?.key,
                    },
                });
            } else {
                fetchBaselineUpliftData({
                    variables: {
                        eventData: JSON.stringify(variables),
                        planId: selectedPlan?.planId,
                        frequency: currentFrequency?.key,
                        dim2AttributeName: `${Object.keys(allCheckedAttribute?.[retailerKey])?.[0]}`,
                    },
                });
            }
            //if hide add spends is true, then call checkIfDataPresentAndFetchData with default lump sum of 0
            checkIfDataPresentAndFetchData(addSpends);
        } else {
            setModelRecommendedData([]);
        }
        // setIsLeftSideFilled(checkIfLeftSideFilled());
    }, [addLeverData, editRowData]);

    useEffect(() => {
        setModelRecommendedData([]);
    }, [editMode]);

    return (
        <promoRecommendation.Provider
            value={{
                checkIfDataPresentAndFetchData,
                additionalKpiLoading,
                baselineUpliftLoading,
                baselineLoading,
                modelRecommendedData,
                setAddLeverData,
                addLeverData,
                selectedPlan,
                setSelectPlan,
                loadingForPlanList,
                setLoadingForPlanList,
                selectedKpiList,
                setSelectedKpiList,
                addSpends,
                setAddSpends,
                eventsListData,
                eventsListError,
                eventsListLoading,
                deleteEvent,
                fetchEventsList,
                clearEventsList,
                addEditModal,
                setAddEditModal,
                editPlan,
                editMode,
                setEditMode,
                spendType,
                setSpendType,
                tempRange,
                setTempRange,
                stateForCalender,
                setStateForCalender,
                resetAllStateForAdd,
                editOriginalData,
                editRowData,
                setEditRowData,
                eventsDataFormat,
                eventDataFromOriginalData,
                PreviousUpliftValue,
                PromotionMechanicValue,
                PromotionMechanicValueData,
            }}
        >
            {children}
        </promoRecommendation.Provider>
    );
};

export { promoRecommendation, PromoRecommendationContext };
